// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3mNHS","col":"styles_col__2xSlo"};